module.exports = __webpack_public_path__ + "img/006.b9b4afec.jpg";